import { FC } from "preact/compat";
import { useApp } from "~/core";
import {
    ApprovalColor,
    approvalKindString,
    getApprovalColor,
} from "~/routes/admin-approval/utils";
import { ApproverAvatarProps } from "./interfaces";
import cn from "classnames";

const BORDER_CLASS: Record<ApprovalColor, string> = {
    gray: "border-gray-200",
    blue: "border-blue-600",
    green: "border-green-600",
    red: "border-red-600",
    transparent: "border-transparent",
};

const ApproverAvatar: FC<ApproverAvatarProps> = ({ approval, index }) => {
    const { api } = useApp();
    const user = api.employee.get(approval.approver);
    const fallbackText =
        user?.preferred_username?.slice(0, 2) ??
        approval.email?.slice(0, 2) ??
        "?";
    const title = `${approvalKindString(approval)} by ${
        user?.preferred_username ?? approval.email ?? "Unknown"
    }`;

    return (
        <div
            style={{
                transform: `translateX(-${index * 8}px)`,
            }}
            title={title}
            className={cn(
                "p-0.5 rounded-full border-[3px] text-sm bg-white",
                BORDER_CLASS[getApprovalColor(approval)],
            )}
        >
            <div className="size-7 rounded-full flex items-center justify-center opacity-70 group-hover:opacity-100">
                {user ? (
                    <img
                        src={user.picture}
                        alt={user.name}
                        className="rounded-full object-cover w-full h-full"
                    />
                ) : (
                    <span className="text-gray-500">{fallbackText}</span>
                )}
            </div>
        </div>
    );
};

export default ApproverAvatar;
